import { RouteObject } from 'react-router';

import { RouteErrorBoundary } from 'routing/components/RouteErrorBoundary';

export function routeObjectsWithRootErrorBoundary(
  routeObjects: RouteObject[],
): RouteObject[] {
  return [
    {
      errorElement: <RouteErrorBoundary />,
      children: routeObjects,
    },
  ];
}
